import axiosInstance from '../services/axios-instance';

const downloadExcel = async (url: string, fileName: string): Promise<void> => {
  const response = await axiosInstance.get(url, { responseType: 'blob' });
  const blob = new Blob([response.data], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = fileName;
  link.click();
  URL.revokeObjectURL(link.href);
};

export const exportClientTimelogToExcel = (clientId: number, month: number, year: number): Promise<void> => {
  return downloadExcel(`/export/client/${clientId}/month/${month}/year/${year}`, `client_${clientId}_${month}_${year}.xlsx`);
};

export const exportOrganizationTimelogToExcel = (organizationId: number, month: number, year: number): Promise<void> => {
  return downloadExcel(`/export/organization/${organizationId}/month/${month}/year/${year}`, `organization_${organizationId}_${month}_${year}.xlsx`);
};
